__turbopack_context__.v({
  "bar": "mini-bar-chart-module-scss-module__hHNioG__bar",
  "emptyPattern": "mini-bar-chart-module-scss-module__hHNioG__emptyPattern",
  "root": "mini-bar-chart-module-scss-module__hHNioG__root",
});
